import { ref } from 'yup';
import { yupObject, yupString } from '../../yup';

import { ApplicantType } from '@/helpers/const';
import dayjs from '@/helpers/dayjs';

export const applicantSimpleSchema = () =>
  yupObject({
    type: yupString().oneOf(Object.values(ApplicantType)).required(),
    firstName: yupString()
      .required()
      .test('len', 'Max characters input is 128', (val) => val.length <= 128)
      .label('First name'),
    lastName: yupString()
      .required()
      .test('len', 'Max characters input is 128', (val) => val.length <= 128)
      .label('Last name'),
    birthdate: yupString()
      .test(
        'is-valid-birthdate',
        'Birthday cannot be invalid or be a future date',
        (value) => dayjs().format('YYYY-MM-DD') >= (value ?? ''),
      )
      .required()
      .label('Birthday'),
    mobile: yupString()
      .transform((value) => (value === '' ? undefined : value))
      .matches(/^(\+\d{11,15}|04\d{8})$/, '${path} must be valid')
      .when('type', {
        is: ApplicantType.PRIMARY,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.optional(),
      })
      .label('Mobile number'),
    email: yupString()
      .transform((value) => (value === '' ? undefined : value))
      .email()
      .when('type', {
        is: ApplicantType.PRIMARY,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.optional(),
      })
      .label('This'),
    confirmEmail: yupString()
      .oneOf([ref('email'), ''], 'Email must match')
      .when('type', {
        is: ApplicantType.PRIMARY,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.optional(),
      })
      .label('Email confirmation'),
    relationshipStatus: yupString().required().label('Relationship status'),
  });

export const applicantBrokerQuoteSimpleSchema = () =>
  yupObject({
    type: yupString().oneOf(Object.values(ApplicantType)).required(),
    birthdate: yupString()
      .test(
        'is-valid-birthdate',
        'Birthday cannot be invalid or be a future date',
        (value) => dayjs().format('YYYY-MM-DD') >= (value ?? ''),
      )
      .required()
      .label('Birthday'),
    relationshipStatus: yupString().required().label('Relationship status'),
  });
